<template>
  <el-dialog
    v-if="model"
    title="翻新设备详情"
    :visible.sync="visible"
    width="560px"
    :show-close="false"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <div slot="title" class="flex-row-between mt-20">
      <div>翻新设备详情</div>
      <div>
        <el-button
          type="info"
          size="mini"
          v-permission="Auth.usedDeviceUpdate"
          plain
          v-if="model.status == 1"
          @click="updateDeviceStatus(10)"
          :loading="submiting"
          >暂停销售</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-if="model.status == 10"
          v-permission="Auth.usedDeviceUpdate"
          plain
          @click="updateDeviceStatus(1)"
          :loading="submiting"
          >恢复出售</el-button
        ><el-button
          type="success"
          size="mini"
          v-if="model.status != 100"
          v-permission="Auth.usedDeviceUpdate"
          plain
          @click="updateDeviceStatus(100)"
          :loading="submiting"
          >已售出</el-button
        >
      </div>
    </div>
    <ul class="modal-detail">
      <li>
        <div class="title">设备描述</div>
        <div>{{ model.material_desc }}</div>
      </li>
      <li>
        <div class="title">件号</div>
        <div>{{ model.material }}</div>
      </li>
      <li>
        <div class="title">维修报告</div>
        <div>
          <div class="flex-row" v-for="file in model.report_files">
            <a class="mr-10" :href="host + file.url" target="_blank">{{
              file.name
            }}</a>
            <span class="pointer" v-show="!isMobile()" @click="download(file)"
              >下载</span
            >
          </div>
          <span v-if="!model.report_files || model.report_files.length == 0"
            >无</span
          >
        </div>
      </li>
      <li>
        <div class="title">数量</div>
        <div>{{ model.quantity }}</div>
      </li>
      <li>
        <div class="title">单价</div>
        <div>{{ model.price }}</div>
      </li>
      <li>
        <div class="title">序列号</div>
        <div>{{ model.serial_number }}</div>
      </li>
      <li>
        <div class="title">生产日期</div>
        <div>{{ model.product_date }}</div>
      </li>
      <li>
        <div class="title">备注</div>
        <div>
          <span
            class="text-danger"
            v-if="model.remark && model.remark.length > 0"
            >{{ model.remark }}</span
          >
          <span v-else>无</span>
        </div>
      </li>
      <li>
        <div class="title">图片</div>
        <div>
          <viewer
            v-if="model.pics && model.pics.length > 0"
            class="viewer"
            ref="viewer"
          >
            <template slot-scope="scope2">
              <auth-img
                tag="el-image"
                style="width: 30px; height: 30px; margin-right: 5px"
                v-for="pic in model.pics"
                :key="pic"
                :src="pic"
                :preview-src-list="model.pics"
              />
            </template>
          </viewer>
          <span v-else>无</span>
        </div>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'
import { isMobile } from '@/util/index'
import download from 'downloadjs'
import { UsedDeviceStatusMap } from '../../config/global'
import { updateUsedDevice } from '../../service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      host,
      isMobile,
      thumbnailImagePath,
      originImagePath,
      submiting: false,
      visible: this.show,
    }
  },
  created() {},
  methods: {
    download(file) {
      var x = new XMLHttpRequest()
      x.open('GET', this.host + file.url, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        download(e.target.response, file.name)
      }
      x.send()
    },
    updateDeviceStatus(status) {
      let device = this.model
      let name = UsedDeviceStatusMap[status].name
      let tips = ''
      if (device.quantity > 1) {
        tips =
          '<p class="text-danger">若设备尚有库存，请直接在编辑设备中修改设备数量</p>'
      }
      this.$confirm('确定变更状态为：' + name + tips, '提示', {
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        let that = this
        device.status = status
        this.submiting = true
        updateUsedDevice(device).then((res) => {
          if (res.code == 0) {
            that.$message.success('操作成功！')
            if (res.data.status == 100) {
              that.$emit('sold', res.data)
            }
            that.visible = false
          }
          that.submiting = false
        })
      })
    },
  },
}
</script>

<style scoped>
.modal-detail li {
  line-height: 2;
  display: flex;
  margin-bottom: 10px;
}
.modal-detail li .title {
  display: inline-block;
  width: 80px;
  color: gray;
}

.modal-detail li div:last-child {
  flex: 1;
}
</style>